import React from 'react';
import PropTypes from 'prop-types';
import { Svg, G, Polygon, Circle, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function ErrorIcon(props) {
  const { color, ...svgProps } = props;

  return (
    <Svg {...svgProps} viewBox="0 0 25 25">
      <G fill="none" fill-rule="evenodd">
        <Path
          fill="#FF3838"
          d="M12.4997917,0.000208333333 C5.59666667,0.000208333333 -0.000208333333,5.59708333 -0.000208333333,12.5002083 C-0.000208333333,19.4033333 5.59666667,25.0002083 12.4997917,25.0002083 C19.4039583,25.0002083 24.9997917,19.4033333 24.9997917,12.5002083 C24.9997917,5.59708333 19.4039583,0.000208333333 12.4997917,0.000208333333 M12.4997917,1.25020833 C18.7029167,1.25020833 23.7497917,6.29708333 23.7497917,12.5002083 C23.7497917,18.7033333 18.7029167,23.7502083 12.4997917,23.7502083 C6.29666667,23.7502083 1.24979167,18.7033333 1.24979167,12.5002083 C1.24979167,6.29708333 6.29666667,1.25020833 12.4997917,1.25020833"
          mask="url(#error-b)"
        />
        <Path
          fill="#FF3838"
          d="M12.4632292,13.7977083 C12.1184375,13.7977083 11.8382292,13.5175 11.8382292,13.1727083 L11.8382292,8.48416667 C11.8382292,8.139375 12.1184375,7.85916667 12.4632292,7.85916667 C12.8080208,7.85916667 13.0882292,8.139375 13.0882292,8.48416667 L13.0882292,13.1727083 C13.0882292,13.5175 12.8080208,13.7977083 12.4632292,13.7977083"
        />
        <Path
          fill="#FF3838"
          d="M12.4621875,5.43791667 C12.1746875,5.43791667 11.8465625,5.74 11.5861458,6.24416667 L6.75802083,15.611875 C6.48197917,16.149375 6.44135417,16.6285417 6.6434375,16.961875 C6.8465625,17.2941667 7.29135417,17.4785417 7.8965625,17.4785417 L17.0288542,17.4785417 C17.6340625,17.4785417 18.0788542,17.2941667 18.2819792,16.961875 C18.4840625,16.6285417 18.4434375,16.149375 18.1673958,15.611875 L13.3392708,6.24416667 C13.0788542,5.74 12.7507292,5.43791667 12.4621875,5.43791667 M17.0288542,18.7275 L7.8965625,18.7275 C6.85385417,18.7275 6.0090625,18.3222917 5.57677083,17.6129167 C5.14447917,16.9035417 5.16947917,15.965 5.64760417,15.0389583 L10.4757292,5.67229167 C11.1403125,4.380625 12.0069792,4.18791667 12.4621875,4.18791667 C12.9184375,4.18791667 13.7851042,4.380625 14.4496875,5.67229167 L19.2778125,15.0389583 C19.7559375,15.965 19.7809375,16.9035417 19.3486458,17.6129167 C18.9163542,18.3222917 18.0715625,18.7275 17.0288542,18.7275"
        />
        <Path
          fill="#FF3838"
          d="M12.46625,15.8840625 C12.2995833,15.8840625 12.1433333,15.8111458 12.0183333,15.6965625 C11.90375,15.5819792 11.84125,15.4257292 11.84125,15.2590625 C11.84125,15.0923958 11.90375,14.9257292 12.0183333,14.8111458 C12.0808333,14.7590625 12.1433333,14.7069792 12.2266667,14.6757292 C12.4558333,14.5819792 12.7370833,14.6444792 12.90375,14.8111458 C13.0183333,14.9257292 13.09125,15.0923958 13.09125,15.2590625 C13.09125,15.4257292 13.0183333,15.5819792 12.90375,15.6965625 C12.7891667,15.8111458 12.6329167,15.8840625 12.46625,15.8840625"
        />
      </G>
    </Svg>
  );
}

ErrorIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

ErrorIcon.defaultProps = {
  height: 120,
  width: 120,
};

export default pure(ErrorIcon);
